import React from "react";
import { useTranslation } from "./useTranslation";

const AboutUs = () => {
  const { t } = useTranslation();

  const principles = t("about.principles.items", { returnObjects: true });

  return (
    <main className="min-h-screen bg-white text-gray-900">
      <article className="max-w-4xl mx-auto px-6 lg:px-8 py-20">
        {/* Title Page */}
        <header className="text-center mb-16">
          <h1 className="text-4xl font-serif font-bold tracking-tight mb-4">
            {t("about.title")}
          </h1>
        </header>

        {/* Overview */}
        <section className="mb-12">
          <h2 className="text-2xl font-serif font-semibold mb-3">
            {t("about.sections.overview.heading")}
          </h2>
          <p className="text-base text-gray-800 leading-relaxed">
            {t("about.sections.overview.body")}
          </p>
        </section>

        {/* Mission */}
        <section className="mb-12">
          <h2 className="text-2xl font-serif font-semibold mb-3">
            {t("about.sections.mission.heading")}
          </h2>
          <p className="text-base text-gray-800 leading-relaxed">
            {t("about.sections.mission.body")}
          </p>
        </section>

        {/* Background */}
        <section className="mb-12">
          <h2 className="text-2xl font-serif font-semibold mb-3">
            {t("about.sections.background.heading")}
          </h2>
          <p className="text-base text-gray-800 leading-relaxed mb-4">
            {t("about.sections.background.p1")}
          </p>
          <p className="text-base text-gray-800 leading-relaxed mb-4">
            {t("about.sections.background.p2")}
          </p>
          <p className="text-base text-gray-800 leading-relaxed">
            {t("about.sections.background.p3")}
          </p>
        </section>

        {/* Operations */}
        <section className="mb-12">
          <h2 className="text-2xl font-serif font-semibold mb-3">
            {t("about.sections.operations.heading")}
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-base text-gray-800 leading-relaxed">
            <li>
              <span className="font-medium">{t("about.sections.operations.items.0.title")}</span>{" "}
              {t("about.sections.operations.items.0.desc")}
            </li>
            <li>
              <span className="font-medium">{t("about.sections.operations.items.1.title")}</span>{" "}
              {t("about.sections.operations.items.1.desc")}
            </li>
            <li>
              <span className="font-medium">{t("about.sections.operations.items.2.title")}</span>{" "}
              {t("about.sections.operations.items.2.desc")}
            </li>
          </ul>
        </section>

        {/* Corporate Information */}
        <section className="mb-12">
          <h2 className="text-2xl font-serif font-semibold mb-3">
            {t("about.sections.corporate.heading")}
          </h2>
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-medium mb-2">
                {t("about.sections.corporate.company.title")}
              </h3>
              <p className="text-base text-gray-800 leading-relaxed">
                <strong>{t("about.sections.corporate.company.nameLabel")}</strong>{" "}
                {t("about.sections.corporate.company.name")}
              </p>
              <p className="text-base text-gray-800 leading-relaxed">
                <strong>{t("about.sections.corporate.company.repLabel")}</strong>{" "}
                {t("about.sections.corporate.company.rep")}
              </p>
              <p className="text-base text-gray-800 leading-relaxed">
                <strong>{t("about.sections.corporate.company.addrLabel")}</strong>{" "}
                {t("about.sections.corporate.company.addr")}
              </p>
              <p className="text-base text-gray-800 leading-relaxed">
                <strong>{t("about.sections.corporate.company.contactLabel")}</strong>{" "}
                <a href="mailto:support@routedlabs.com" className="underline">
                  support@routedlabs.com
                </a>
              </p>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-2">
                {t("about.sections.corporate.agent.title")}
              </h3>
              <p className="text-base text-gray-800 leading-relaxed">
                <strong>{t("about.sections.corporate.agent.nameLabel")}</strong>{" "}
                {t("about.sections.corporate.agent.name")}
              </p>
              <p className="text-base text-gray-800 leading-relaxed">
                <strong>{t("about.sections.corporate.agent.addrLabel")}</strong>{" "}
                {t("about.sections.corporate.agent.addr")}
              </p>
            </div>
          </div>
        </section>


        {/* Communications */}
        <section className="pt-10 border-t border-gray-200">
          <h2 className="text-2xl font-serif font-semibold mb-3">
            {t("about.sections.comms.heading")}
          </h2>
          <p className="text-base text-gray-800 leading-relaxed">
            {t("about.sections.comms.p1.prefix")}{" "}
            <a href="mailto:support@routedlabs.com" className="underline">
              support@routedlabs.com
            </a>
            {t("about.sections.comms.p1.suffix")}
          </p>
        </section>
      </article>
    </main>
  );
};

export default AboutUs;
